import React, { useState, useMemo } from "react"
import { MRT_ColumnDef } from "material-react-table";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material"
import { relationships_purchase_order_post } from "../../../services/expenses/purchase_orders";
import MATERIAL_TABLE_CONTAINER from "../../../main_components/material_table/table_container";
import MODAL_TABLE from "../../../main_components/modal/modal_Table";
interface CustomTableProps {
  data: any;
  onCloseCustom: () => void;

}


const OrdenCompra: React.FC<CustomTableProps> = ({ data, onCloseCustom }) => {

  const [modalT, setmodalT] = useState(false)



  const columns: MRT_ColumnDef<any>[] = useMemo(
    () => [

      {
        header: "Concepto",
        accessorKey: "description",
        id: "description",
        size: 300,
      },
      {
        header: "Cantidad",
        accessorKey: "quantity",
        id: "quantity",
        size: 120,
      },

      {
        header: "Precio",
        accessorKey: "price",
        id: "price",
        size: 130,
      },
      {
        header: "Clave Unida",
        accessorKey: "clave_unidad",
        id: "clave_unidad",
        size: 140,
      },
      {
        header: "clave_prod_serv",
        accessorKey: "clave_prod_serv",
        id: "clave_prod_serv",
        size: 140,
      }
    ],

    []
  );


  console.log(data)



  const handleRelationShips = async (id_status: number) => {
    setmodalT(true)
    try {
      await relationships_purchase_order_post(data.details_invoice.relationships[0].id_relationship_fk, { check_status_and_details: false, id_status: id_status })
      setmodalT(false)

      onCloseCustom()
    } catch (error: any) {
      alert(error.response.data.errorMessage.es)
      setmodalT(false)

    }
  }


  return (
    <Box sx={{ bgcolor: "#f5f5f5", p: 2 }}>

      <MODAL_TABLE open={false} message={''} message2={''} modalGeneral={false} modalT={modalT} />

      <Paper sx={{ m: 2, p: 3 }}>
        {/* Tabla de Detalles */}
        <Grid container spacing={2} alignItems="stretch">
          {/* Información Proveedor */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Información Proveedor
                </Typography>
                {[
                  ["Orden", data.details.proveedor.order_number],
                  ["Fecha de Registro", data.details.proveedor.date_register],
                  ["Nombre proveedor", data.details.proveedor.supplier_name],
                  ["RFC", data.details.proveedor.supplier_rfc],
                ].map(([label, value]) => (
                  <Grid container spacing={1} key={label}>
                    <Grid item xs={5}>
                      <Typography color="text.secondary">{label}:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography fontWeight="medium">{value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* Dirección Entrega */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Dirección Entrega
                </Typography>
                {[
                  ["Calle", data.address.street],
                  ["Colonia", data.address.neighborhood],
                  ["Ciudad", data.address.city],
                  ["Estado", data.address.state],
                ].map(([label, value]) => (
                  <Grid container spacing={1} key={label}>
                    <Grid item xs={5}>
                      <Typography color="text.secondary">{label}:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography fontWeight="medium">{value}</Typography>
                    </Grid>
                  </Grid>
                ))}
              </CardContent>
            </Card>
          </Grid>

          {/* Acciones */}
          <Grid item xs={12} md={4}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Acciones
                </Typography>
                {data?.status_code == 5 ? <div>Orden de Compta Cancelada</div> :
                  data?.status_code == 2 ?
                    <Grid container spacing={2} mb={2}>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          onClick={() => handleRelationShips(4)}

                          sx={{ bgcolor: "green", color: "white", width: "100%" }}
                        >
                          AUTORIZAR
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          onClick={() => handleRelationShips(3)}
                          sx={{ bgcolor: "#ff0033", color: "white", width: "100%" }}
                        >
                          RECHAZAR
                        </Button>
                      </Grid>
                    </Grid> :
                    <div>Acciones no disponibles</div>
                }
                <Typography variant="body2" color="text.secondary">
                  Total del Pedido:
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  ${Number(data.total || 0).toLocaleString()}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box mt={4}>
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Detalles:
          </Typography>
          <MATERIAL_TABLE_CONTAINER
            columns={columns}
            data={data.details.concepts}
            modalT={false}
            isLoading={false}
            search_filters={<div></div>}
            component_header={<div></div>}
            file_name_export="Detalles"
            update_identifiers={[]}
          ></MATERIAL_TABLE_CONTAINER>
        </Box>
      </Paper>

    </Box>
  )
}


export default OrdenCompra;